import axiosServices from '@/common/infrastructure/axios';
import { raptorJobRestEndpoints } from './endpoints';
import { AxiosError } from 'axios';
import { CreateMultiDayJobApiError, CreateMultiDayJobError, CreateMultiDayJobRequest } from '@/raptorjob/domain/raptor-jobs-types';

export interface CreateMultiDayJobRestOptions {
  useMock: boolean;
}

export const postCreateMultiDayJob = async (
  payload: CreateMultiDayJobRequest & { id?: string },
  { useMock }: CreateMultiDayJobRestOptions
): Promise<CreateMultiDayJobRequest & { id: string }> => {
  const { VITE_API_BASE_URL, VITE_MOCK_API_BASE_URL } = import.meta.env as Record<string, string | undefined>;
  const base = useMock ? VITE_MOCK_API_BASE_URL : VITE_API_BASE_URL;
  if (!base) throw new Error(`Missing ${useMock ? 'VITE_MOCK_API_BASE_URL' : 'VITE_API_BASE_URL'}`);

  const path = useMock ? raptorJobRestEndpoints.mockRaptorJobs : raptorJobRestEndpoints.createMultiDayJob;

  try {
    const { data } = await axiosServices.post<CreateMultiDayJobRequest & { id: string }>(`${base}${path}`, payload, {
      headers: { 'Content-Type': 'application/json' }
    });
    return data;
  } catch (error: unknown) {
    const axiosError = error as AxiosError<CreateMultiDayJobError>;
    const status = axiosError?.response?.status;
    if (status === 422 && axiosError.response?.data?.error) {
      throw new CreateMultiDayJobApiError('Validation failed creating multi-day job', axiosError.response.data, status);
    }

    throw error;
  }
};
